import { useState } from 'react';
import { Col, DatePicker, Layout, Row, Space, Typography } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

import { Header } from 'pm-components';

import { SideMenu } from '../SideMenu';
import { SummaryChart, MonthlyChart } from './charts';

const monthStartUTC = (d: Dayjs) => new Date(Date.UTC(d.year(), d.month(), 1)).toISOString();
const monthEndUTC = (d: Dayjs) => new Date(Date.UTC(d.year(), d.month() + 1, 0, 23, 59, 59, 999)).toISOString();

const { Content } = Layout;
const { Text } = Typography;

export function Analytics() {
    const [menuCollapsed, setMenuCollapsed] = useState(true)
    const [range, setRange] = useState<[Dayjs, Dayjs]>([
        dayjs().startOf('month'),
        dayjs().startOf('month'),
    ]);

    const from = monthStartUTC(range[0]);
    const to = monthEndUTC(range[1]);

    return (
        <>
            <Header
                leftIcon={<MenuOutlined />}
                onLeftClick={() => setMenuCollapsed(!menuCollapsed)}
            >
                <Text className={'h2'}>Analytics</Text>
            </Header>

            <SideMenu menuCollapsed={menuCollapsed} />

            <Content onClick={() => setMenuCollapsed(true)}>
                <Row gutter={[0, 10]} className={'mb-80'}>
                    <Col xs={24} className={'text-center'}>
                        <Space>
                            <DatePicker
                                picker={'month'}
                                value={range[0]}
                                allowClear={false}
                                disabledDate={(date) => date.isAfter(range[1])}
                                onChange={(value) => value && setRange([value, range[1]])}
                            />
                            <DatePicker
                                picker={'month'}
                                value={range[1]}
                                allowClear={false}
                                disabledDate={(date) => date.isBefore(range[0])}
                                onChange={(value) => value && setRange([range[0], value])}
                            />
                        </Space>
                    </Col>
                    <Col xs={24}>
                        <SummaryChart from={from} to={to} />
                    </Col>
                    <Col xs={24}>
                        <MonthlyChart from={from} to={to} />
                    </Col>
                </Row>
            </Content>
        </>
    )
}
